/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-destructuring, one-var */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Navbar} from 'react-bootstrap';
import {Scrollbars} from 'react-custom-scrollbars';
import Can from '../common/guards/can';


import SideMenuItem from './menu-item';
import SideMenuDropdown from './menu-dropdown';

import {navBarLinks, navBarLinksAdmin, navBarLinksReps, navBarLinksPreLogin} from '../../data/navbarLinks';

import './sidenav.css';
import {USER_TYPE_ADMIN, USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_PRE_LOGIN} from '../../data/userTypes';

class SideNav extends Component {
  getOpenedMenu = () => localStorage.getItem('navbarToggles') || '';
  toggleMenu = (key) => {
    const currentKey = localStorage.getItem('navbarToggles');
    if (currentKey === key) {
      localStorage.setItem('navbarToggles', '');
      this.setState({openedMenu: ''});
    } else {
      localStorage.setItem('navbarToggles', key);
      this.setState({openedMenu: key});
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      openedMenu: this.getOpenedMenu()
    };
  }

  render() {
    const {type, menuOpened} = this.props;

    const linkGroups = {
      [USER_TYPE_ADMIN]: navBarLinksAdmin,
      [USER_TYPE_RETAILER]: navBarLinks,
      [USER_TYPE_REP]: navBarLinksReps,
      [USER_TYPE_PRE_LOGIN]: navBarLinksPreLogin,
    };

    const minHeights = {
      [USER_TYPE_ADMIN]: 'calc(100vh - 150px)',
      [USER_TYPE_RETAILER]: 'calc(100vh - 300px)',
      [USER_TYPE_REP]: 'calc(100vh - 300px)',
      [USER_TYPE_PRE_LOGIN]: 'calc(100vh - 300px)',
    };

    const links = linkGroups[type];
    const heightMin = minHeights[type];

    return (
      <Navbar.Collapse className={menuOpened ? 'collepsed' : ''}>
        <Scrollbars
          autoHeight
          autoHeightMax={heightMin}
          autoHeightMin={heightMin}
          autoHide
          renderThumbVertical={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                backgroundColor: '#d80d48'
              }}
            />
          )}
          renderTrackVertical={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                position: 'absolute',
                width: '8px',
                right: '0px',
                bottom: '2px',
                top: '2px',
                borderRadius: '3px',
                backgroundColor: '#7e1129'
              }}
            />
          )}
          renderView={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                overflowX: 'hidden'
              }}
            />
          )}
        >
          <ul className="sidebar-nav" id="sidebar-nav">
            {links.map((item, index) => {
              let action = true,
                subjectClass = '';
              if (item.permissions) {
                action = item.permissions.action;
                subjectClass = item.permissions.subjectClass;
              }
              if (item.hasOwnProperty('children')) {
                const key = `dd_${index}`;
                return (
                  <Can action={action} key={key} subjectClass={subjectClass}>
                    <SideMenuDropdown
                      className="nav-item"
                      handleOpen={this.toggleMenu}
                      open={this.state.openedMenu === key}
                      title={item.title}
                      toggleKey={key}
                    >
                      {item.children.map((child, childKey) => {
                        let childAction = true;
                        let childSubjectClass = '';
                        if (child.permissions) {
                          childAction = child.permissions.action;
                          childSubjectClass = child.permissions.subjectClass;
                        }

                        const show = !(child.hidePseudo && this.props.pseudo);

                        return (
                          <Can action={childAction} key={`sidenav_${childKey}`} subjectClass={childSubjectClass}>
                            {show && <SideMenuItem href={child.href} id={`sidenav_${childKey}`} title={child.title}/>}
                          </Can>
                        );
                      })}
                    </SideMenuDropdown>
                  </Can>
                );
              }
              return (
                <Can action={action} key={`sidenav_${index}`} subjectClass={subjectClass}>
                  <SideMenuItem handleOpen={this.toggleMenu} href={item.href} id={`sidenav_${index}`} title={item.title}/>
                </Can>
              );
            })}
          </ul>
        </Scrollbars>
      </Navbar.Collapse>
    );
  }
}


const mapStateToProps = state => ({
  pseudo: state.viewConfig.profile.attributes['pseudo-login'],
});

export default connect(mapStateToProps)(SideNav);



// WEBPACK FOOTER //
// ./src/components/sidenav/index.jsx